import { useParams, useSearchParams } from 'react-router-dom';

import { Navbar } from 'apps/dashboard/shared/scripts/components';
import { useIsCardDelivered } from 'apps/shared/scripts/hooks';

import RightHeader from './RightHeader';

const CardNavbar = () => {
  const { cardId } = useParams();
  const { isDelivered, isLoading } = useIsCardDelivered({ id: cardId! });
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('rd');

  return (
    <Navbar
      goBack={!!redirect}
      rightHeader={
        !isLoading && <RightHeader cardId={cardId!} isDelivered={isDelivered} />
      }
    />
  );
};

CardNavbar.displayName = 'CardNavbar';

export default CardNavbar;
